module.exports = __webpack_public_path__ + "static/logo_clear250x37-888e8229720e8e0d80ac999b5cff5c7c.png";